<template>
    <div id="app">
        <search-tool-module />
    </div>
</template>

<script>

    import Vue from 'vue';
    import './styles/main.scss';


    import ElementUI from 'element-ui';
    import locale from 'element-ui/lib/locale/lang/en'

    import { FontAwesomeLayers, FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import SearchToolModule from './components/SearchToolModule';


    import AsyncComputed from 'vue-async-computed';
    Vue.use(AsyncComputed);
    Vue.use(ElementUI,{ locale });

    Vue.component('font-awesome-icon', FontAwesomeIcon);
    Vue.component('font-awesome-layers', FontAwesomeLayers);

    export default {
        name: 'RazzSearchTool',
        components: {SearchToolModule},
    };
</script>

<style lang="scss" type="text/scss">
    @import "styles/main";

    #app {
        position: relative;
        z-index: 1;
    }
</style>
